const STATUS = {
  open: 'Open',
  new: 'New',
  confirmed: 'Confirmed',
  done: 'Done',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  active: 'Aktiv',
  inactive: 'Inaktiv',
};

export default STATUS;
